class ScAccordion extends HTMLElement {
  constructor() {
    super();
    this.accTrigger = this.querySelectorAll(".js-accordion-trigger");

    this.addEventListener("click", (e) => {
      if (e.target.classList.contains("js-accordion-trigger")) {
        if (e.target.classList.contains("is-active")) {
          this.closeAccordion(e.target)
        } else {
          let activeAccordion = this.querySelector('.js-accordion-trigger.is-active')
          activeAccordion ? this.closeAccordion(activeAccordion) : ''
          this.openAccordion(e.target)
        }

        setTimeout(() => {
          this.scrollToAccordion(e.target);
        }, 300)
      }
    });
  }

  closeAccordion(accordion) {
    accordion.classList.remove("is-active");
    accordion.nextElementSibling.style.maxHeight = null;
    let arrow = accordion.querySelector('.js-accordion-arrow')
    if (arrow) arrow.classList.remove('is-active')
  }

  openAccordion(accordion) {
    accordion.classList.add("is-active");
    accordion.nextElementSibling.style.maxHeight =
      accordion.nextElementSibling.scrollHeight + "px";
    let arrow = accordion.querySelector('.js-accordion-arrow')
    if (arrow) arrow.classList.add('is-active')
  }

  scrollToAccordion(accordionTrigger) {
    requestAnimationFrame(() => {
      const accordionRect = accordionTrigger.getBoundingClientRect();
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const targetTop = scrollTop + accordionRect.top - this.getHeaderHeight() - 80;
      window.scrollTo({
        top: targetTop,
        behavior: "smooth",
      });
    });
  }
  
  getHeaderHeight() {
    const header = document.querySelector("header");
    return header ? header.offsetHeight : 0;
  }
}

customElements.define("sc-accordion", ScAccordion);